export const formatsFields = {
  CPF: '###.###.###-##',
  CNPJ: '##.###.###/####-##',
};
